/**
 * List-group
 */

import 'bootstrap/js/dist/tab';

// Module dependencies
import 'protons';
import 'atoms/badge';

// Module template
import './_list-group.twig';

// Import custom sass, includes Bootstrap sass
import './_list-group.scss';

export const name = 'list-group';

export function disable() {}

export function enable() {}

export default enable;
